export default {
    device_overview_title: 'Device',
    device_overview_actions: 'Actions',
    device_overview_device_name: 'Device Name',
    device_overview_status: 'Status',
    device_overview_iccid: 'ICCID',
    device_overview_imei: 'IMEI',
    device_overview_serial: 'Serial',
    device_overview_account: 'Account',
    device_overview_created_by: 'Created By',
    device_overview_network: 'Network',
    device_overview_device_model: 'Device Model',
    device_overview_manufacturer: 'Manufacturer & Brand',
    device_overview_sim_phone: 'SIM Phone',
    device_overview_created_at: 'Created At',
    device_overview_unit_time: 'Unit Time',
    device_overview_server_time: 'Server Time',
    device_overview_last_message_time: 'Last Message Time',
    device_overview_age: 'Age',
    device_overview_sim_provider_account: 'SIM Provider Account',
    device_overview_script: 'Script',
    device_overview_device_category: 'Device Category',
    device_overview_rma_number: 'RMA Number',
    device_overview_refurbish_from: 'Refurbish From',
    device_overview_activities: 'Activities',
    device_overview_raw_data: 'Raw Data',
    device_overview_script: "Script",
    device_overview_puls_customer: "Calamp Account",
    device_overview_firmware: "Firmware",
    device_overview_edit: "Edit",
    device_overview_live_streaming: "Live Streaming",

    device_overview_edit_sim_card: 'Edit & Swap Sim Card',
    device_overview_change_device_script: "Change Device Script",
    device_overview_mark_as_rma: "Mark as RMA",
    device_overview_send_command: "Send Command",
    device_overview_change_sim_provider: "Change SIM Provider",
    device_overview_change_puls_customer: "Change Calamp Account",
    
    device_overview_tab_command: "Command",
    device_overview_tab_features: "Features",
    device_overview_tab_troubleshooting_events: "Troubleshooting",
    device_overview_: "",
    device_overview_device_not_found: "Device not found",
    device_overview_device_overview: "Device Overview",
    device_overview_tab_vidfleet_configuration: "VidFleet Configuration",

    device_overview_calamp_info: "Calamp",
    device_overview_refurbish_message: "Click to see the original device",
    device_overview_activate_camera_sim_card: "Activate Camera SIM Card",

    device_overview_format_sd_card: "Format SD Card",
    device_overview_unpairing_the_gps: "Unpairing the gps",
    device_overview_associate_to_gps: "Pair Device",
    device_overview_request_device_log: "Request Device Log",
    device_overview_linked_device_esn: "Paired Device",
    device_overview_device_linked_to: "Device paired to",
    device_overview_sim_info: "SIM Info",
    device_overview_refurbish: "Refurbish This Device",
    device_overview_device_refurbish: "Refurbished Device",
    device_overview_camera_mode: "Mode",
    device_overview_refurbish_message: "Refurbish device can't be edited",
    device_overview_rma_message: "Device in RMA can't be edited",
    device_overview_unpair_device: "Unpair Device",
    device_overview_tab_notes: "Notes",
    device_overview_refresh_config: "Refresh VidFleet Config",
    device_overview_refresh_config_message: "Device config has been refreshed",
    device_overview_refresh_cameras_device_config: "Refresh Device Config",
    device_overview_device_timezone: "Timezone",
    device_overview_show_web: "Show In Web",
    device_overview_puls_group: "Group",
    device_overview_assigned_script: "Assigned Script",
    device_overview_refurbished_pool: "Refurbished Pool",
    device_overview_installed: "Installed",
    device_overview_pending_installed: "Pending Installation",
    device_overview_installed_on: "Installed On",
    device_overview_coverage_score: "Diagnostic Score",
    device_overview_converage_updated_on: "Coverage Updated on",
    device_overview_create_diagnostic: "Create Diagnostic",
    device_overview_clip_request: "Clip Request",
    device_overview_battery_level: "Battery Level",
    device_overview_camera_warning: "Camera SD Card Status is",
    device_overview_billing_account: "Billing Account",
};

